// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { connect, useDispatch, useStore, useSelector } from '/data/jenkins/workspace/exam-platform-front/node_modules/@umijs/plugins/libs/dva.tsx';
export { getDvaApp } from './dva';
